function extractNameExclusive(signatureDto) {
    if (signatureDto && (!signatureDto.Id && signatureDto.Name))
        return signatureDto.Name
};

module.exports = extractNameExclusive;